import { render, staticRenderFns } from "./KeypointsDefinition.vue?vue&type=template&id=324ff2dd&scoped=true&"
import script from "./KeypointsDefinition.vue?vue&type=script&lang=js&"
export * from "./KeypointsDefinition.vue?vue&type=script&lang=js&"
import style0 from "./KeypointsDefinition.vue?vue&type=style&index=0&id=324ff2dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324ff2dd",
  null
  
)

component.options.__file = "KeypointsDefinition.vue"
export default component.exports